// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2u9HR","head":"ProcedureTableInfo_head__Zr8O8"};